import { Extension } from '@tiptap/core'

// components
import BubbleMenu from '../BubbleMenu.vue'

// nodes
import AlgoliaAuctions from './Nodes/AlgoliaAuctions/AlgoliaAuctions.js'
import AlgoliaCategory from './Nodes/AlgoliaCategory/AlgoliaCategory.js'
import Auctions from './Nodes/Auctions/Auctions.js'
import Button from './Nodes/Button/Button.js'
import Card from './Nodes/Card/Card.js'
import Categories from "./Nodes/Categories/Categories.js"
import Content from './Nodes/Content/content.js'
import Grid from './Nodes/Grid/Grid.js'
import IFrame from "./Nodes/IFrame/IFrame.js"
import Image from './Nodes/Image/Image.js'
import Navigation from './Nodes/Navigation/Navigation.js'
import Panel from './Nodes/Panel/Panel.js'
import Sales from './Nodes/Sales/Sales'
import Stats from './Nodes/Stats/Stats.js'
import YoutubeVideo from "./Nodes/YoutubeVideo/YoutubeVideo.js";
import Html from "./Nodes/Html/Html.js";
import LiveEvents from './Nodes/LiveEvents/LiveEvents.js'

const BlockEditor = Extension.create({
  name: "BlockEditor",

  addOptions() {
    return {
      editorData: {},
      contentData: {},
    }
  },

  addExtensions() {
    let extensions = [
      AlgoliaAuctions,
      AlgoliaCategory,
      Auctions,
      Button,
      Card,
      Categories,
      Content,
      Grid,
      Html,
      IFrame,
      Image,
      LiveEvents,
      Navigation,
      Sales,
      Stats,
      YoutubeVideo,
    ]

    // Ensure we have valid editorData with elements array
    if (!this.options.editorData || !this.options.editorData.elements) {
      console.warn('BlockEditor: Missing valid editorData with elements array. Falling back to empty elements list.')
      this.options.editorData = this.options.editorData || {}
      this.options.editorData.elements = []
    }

    // Even in preview mode, we should still respect the elements allowed in editorData
    return [
      Panel,
      ...extensions
        .filter(extension => {
          // Only include extensions that are in the elements list
          return this.options.editorData.elements.includes(extension.name)
        })
        .map(extension => {
          if (this.options.editorData.hasOwnProperty(extension.name)) {
            return extension.configure({
              ...this.options.editorData[extension.name],
              data: this.options.contentData
            })
          }

          return extension
        }),
    ]
  },
})

export { BlockEditor, BubbleMenu }

export default BlockEditor
